import { extendTheme, theme as defaultTheme } from '@chakra-ui/react';
import '@fontsource/ubuntu/300.css';
import '@fontsource/ubuntu/400.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';

const breakpoints = {
  ...defaultTheme.breakpoints,
  tabletSmall: '37.5em', // 600px and above
  tabletLarge: '48em', // 768px and above
  desktop: '64em', // 1024px and above
  desktopLarge: '75em', // 1200px and above
};

const theme = extendTheme({
  breakpoints,
  colors: {
    primary: {
      50: '#ecebfe',
      100: '#ceccfb',
      200: '#adaaf8',
      300: '#8d88f5',
      400: '#6e66f2',
      500: '#5b58ec',
      600: '#4a46c7',
      700: '#3935a2',
      800: '#29237d',
      900: '#181257',
    },
    text: {
      main: '#1A202C',
      sub: '#757575',
    },
    background: '#EDF5FD',
    bgPrimary: '#E8F1FE',
    inactive: '#9AA2AB',
    secondary: '#E4A316',
  },
  fonts: {
    heading: `'Ubuntu', sans-serif`,
    body: `'Ubuntu', sans-serif`,
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 700,
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '500',
        py: '21px',
      },
    },
  },
});

export default theme;
